import { useCallback } from "react";
import { postLabor, putLabor } from "../../../api/Labors";
import { logCustomMessage } from "../../../util/logger";
import { SeverityLevel } from "@microsoft/applicationinsights-web";

export default function useAddUpdateTimeEntry() {
  const addUpdateTimeEntry = useCallback(
    async (payload: any, isUpdating: boolean) => {
      const response = isUpdating
        ? await putLabor(payload)
        : postLabor(payload);

      logCustomMessage(
        `Save time entry${isUpdating ? "(PUT)" : "(POST)"}.`,
        SeverityLevel.Information,
        "Labors/Put",
        payload,
        response
      );
      return response;
    },
    []
  );

  return { addUpdateTimeEntry };
}
